import { FC } from 'react';
import {
  Button,
  ModalIcon,
  Spacer,
  Stack,
  TextBody,
  TextTitle,
  ButtonGroup,
} from '@pypestream/design-system';

import { GenericModal, GenericModalProps } from '..';

export type DeleteProviderModalProps = GenericModalProps & {
  connectionName: string;
};

export const DeleteProviderModal: FC<DeleteProviderModalProps> = ({
  modalRef,
  onClose,
  connectionName,
}) => {
  return (
    <GenericModal
      test-id="delete-solution-modal"
      modalRef={modalRef}
      onClose={onClose}
    >
      <Stack justifyContent="center">
        <ModalIcon name="error" />
      </Stack>
      <TextTitle size="small" textAlign="center">
        Delete {connectionName} connection?
      </TextTitle>
      <Spacer size="small" />
      <TextBody variant="secondary" textAlign="center">
        Once deleted, this connection cannot be recovered.
      </TextBody>

      <ButtonGroup slot="footer">
        <Button width="full" variant="secondary" size="large" onClick={onClose}>
          Cancel
        </Button>
        <Button width="full" variant="warning" size="large" onClick={onClose}>
          Delete
        </Button>
      </ButtonGroup>
    </GenericModal>
  );
};
